module.exports = __webpack_public_path__ + "img/prolongation-3.91571d0.png";